<template>
<div style="height: 100%">
  <XTerm v-if="clientId!==''" :terminal="terminal" :client-id="clientId"/>
</div>
</template>

<script>
import XTerm from '_c/xterm'
export default {
  components: {
    XTerm
  },
  data () {
    return {
      terminal: {
        pid: 1,
        name: 'terminal',
        cols: 0,
        rows: 1400
      },
      clientId: ''
    }
  },
  methods: {
  },
  mounted () {
    this.clientId = this.$route.query.id
    console.log(this.$route)
  }
}
</script>

<style></style>
